// extracted by mini-css-extract-plugin
module.exports = {"dropBoxPicker":"dropBoxPicker__2A9bJ"};